import { render, staticRenderFns } from "./creditNewsManage.vue?vue&type=template&id=444d7a8c&"
import script from "./creditNewsManage.vue?vue&type=script&lang=js&"
export * from "./creditNewsManage.vue?vue&type=script&lang=js&"
import style0 from "./creditNewsManage.vue?vue&type=style&index=0&id=444d7a8c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports